import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbd4dc70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "antialiased text-gray-700 bg-gray-100" }
const _hoisted_2 = {
  id: "app",
  class: "flex w-full h-screen justify-center items-center"
}
const _hoisted_3 = {
  key: 0,
  class: "w-full max-w-xl p-3"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "font-bold text-3xl text-center text-indigo-700"
}
const _hoisted_7 = {
  key: 1,
  class: "font-bold text-3xl text-center text-indigo-700"
}
const _hoisted_8 = {
  key: 2,
  class: "instructions-text"
}
const _hoisted_9 = { class: "bg-white p-12 rounded-lg shadow-lg w-full mt-8" }
const _hoisted_10 = {
  key: 3,
  class: "warning-container"
}
const _hoisted_11 = { class: "warning" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "font-bold text-3xl text-center text-indigo-700" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-5xl text-center text-indigo-700" }, "Thank you, your assessment is now complete!", -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Questions = _resolveComponent("Questions")!

  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.questionnaire && _ctx.questionnaire.status !='complete')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.questionnaire.status == 'started')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.currentSection)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_ctx.questionnaire.sections.length > 1)
                          ? (_openBlock(), _createElementBlock("h1", _hoisted_6, " Section " + _toDisplayString(_ctx.questionnaire.current_section_idx + 1) + " - Question " + _toDisplayString(_ctx.currentQuestion.idx + 1), 1))
                          : (_openBlock(), _createElementBlock("h1", _hoisted_7, " Question " + _toDisplayString(_ctx.currentQuestion.idx + 1), 1)),
                        (_ctx.currentSection.instructions)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.currentSection.instructions), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_Questions, {
                            question: _ctx.currentQuestion,
                            onAnswerSelected: _ctx.answerSelected
                          }, null, 8, ["question", "onAnswerSelected"])
                        ]),
                        (_ctx.warning != undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.warning), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("h1", _hoisted_13, "Welcome " + _toDisplayString(_ctx.session.user_name) + ", please click the \"Next\" button below to begin the assessment.", 1)
                ])),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextClicked && _ctx.nextClicked(...args))),
              class: "block mt-4 rounded-lg py-2 px-6 text-lg hover:bg-gray-100 cursor-pointer next-button"
            }, "Next"),
            (_ctx.showBack)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backClicked && _ctx.backClicked(...args))),
                  class: "block mt-4 rounded-lg py-2 px-6 text-lg hover:bg-gray-100 cursor-pointer next-button"
                }, "Back"))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.questionnaire.status == 'complete')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true)
    ])
  ]))
}